import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL;

const handleResponse = (response) => {
    if (response?.data) {
        return response.data;
    }

    return {
        isSuccess: false,
        resultMessage: 'Beklenmeyen cevap alındı.',
    };
};

/**
 * Initiates a 3D Secure payment process
 * @param {Object} payload - Payment initiation data
 * @returns {Promise<Object>} Response containing HTML form to submit to 3D gateway
 */
export async function initiatePayment(payload) {
    try {
        const res = await axios.post(`${baseUrl}/payment/initiate-3d`, payload);
        return handleResponse(res);
    } catch (error) {
        console.error('[Payment] initiate error', error);
        return {
            isSuccess: false,
            resultMessage: error?.response?.data?.resultMessage || error?.message || 'Ödeme başlatılamadı.',
        };
    }
}

/**
 * Gets payment result by transaction ID
 * @param {string} transactionId - Transaction ID  
 * @returns {Promise<Object>} Payment result 
 */
export async function getPaymentResult(transactionId) {
    try {
        const res = await axios.get(`${baseUrl}/payment/result/${transactionId}`);
        return handleResponse(res);
    } catch (error) {
        console.error('[Payment] get result error', error);
        return {
            isSuccess: false,
            resultMessage: error?.response?.data?.resultMessage || error?.message || 'Ödeme sonucu alınamadı.',
        };
    }
}
